var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2497 15.1666C19.2497 15.4888 18.9885 15.7499 18.6663 15.7499C18.3442 15.7499 18.083 15.4888 18.083 15.1666C18.083 14.8444 18.3442 14.5833 18.6663 14.5833C18.9885 14.5833 19.2497 14.8444 19.2497 15.1666Z",
    stroke: "#121217",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54199 7.87508V20.1251C5.54199 21.4137 6.58666 22.4584 7.87533 22.4584H20.1253C21.414 22.4584 22.4587 21.4137 22.4587 20.1251V11.6251C22.4587 10.5205 21.5632 9.62508 20.4587 9.62508H20.1253M20.1253 9.62508H7.58366C6.45608 9.62508 5.54199 8.711 5.54199 7.58341C5.54199 6.45583 6.45608 5.54175 7.58366 5.54175H17.792C19.0807 5.54175 20.1253 6.58642 20.1253 7.87508V9.62508Z",
    stroke: "#121217",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.7814852a3bc5cadb08f5d9802b4ac25d.svg";
export { ForwardRef as ReactComponent };